import { FooterComponent } from './footer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavfooterComponent } from './navfooter/navfooter.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FooterComponent, NavfooterComponent],
  exports: [FooterComponent, NavfooterComponent]
})
export class FooterModule { }



// WEBPACK FOOTER //
// ./src/app/shared-layout/footer/footer.module.ts